<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p.u-mb-ts {{item.desc}}
        AppLink(v-if="item.url" :to="item.url" :title="$t('learnMore')" class="button-link is-small") {{$t('learnMore')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec3Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat technology consulting",
    "pageDesc":"Technology consulting services that help you transform your company into a digital thought leader through advisory services.",
    "mantra":"Designing smart |editorial layouts.",
    "mantraDesc":"Whether you are moving into a new business operations scale or trying to solve business dilemmas, we advise you on how to best utilize cutting edge technology in your most critical  business cases.",
    "sec1Items":{
      "1":{
        "title":"Enterprise solutions",
        "desc":"Eliminate the hassle in your production lines through integrating platforms and systems that automate your workflow. Based on your business needs assessment, we help by setting a change implementation strategy to drive business outcomes with speed.",
        "url":"/services"
      },
      "2":{
        "title":"Security",
        "desc":"Keeping your business and sensitive data safe through security services that ensure your solution reliability",
        "url":"/services/security"
      }
    },
    "sec2":"Embed innovation into your business texture.",
    "sec2Items":{
      "1":{
        "title":"Industry specific",
        "desc":"Whether healthcare, food, oil and gas or other, we help you by reflecting on our past industry experience and customizing a solution around your very specific business case."
      },
      "2":{
        "title":"Partnership approach",
        "desc":"We don't only help you with a technology solution or advisory, we also utilize our partnerships to expand your business growth and create opportunities for prosperity."
      }
    },
    "sec3Items":{
      "1":{
        "title":"Project feasibility",
        "desc":"Before you incur the costs of trial and error, we advise you on the possibility of executing your idea and the best approach of getting it into reality."
      },
      "2":{
        "title":"Performance augmentation",
        "desc":"Whether through systems or technology integration like IoT, we make sure your performance is optimized for the best results."
      },
      "3":{
        "title":"Automation",
        "desc":"Reduce the time and effort needed for your daily business operations by automating your workflow and utilizing your talents full capabilities."
      }
    },


    "cta":"Excel through <br> technology."
  },
  "ar": {
    "pageTitle":"استشارات التكنولوجيا",
    "pageDesc":"نقدم لك استشارات التكنولوجيا تساعدك على تحويل شركتك إلى شركة رائدة في التكنولوجيا من خلال النصائح والحلول التي نوفرها",
    "mantra":"استشارات التكنولوجيا |من أجل حلول مبتكرة.",
    "mantraDesc":"سواء كنت تنتقل الى نطاق جديد في أعمالك أو تحاول حل مشكلات ومعضلات عملك، فنحن ننصحك بكيفية الاستفادة من أفضل التقنيات التكنولوجيا الحديثة في أكثر حالات عملك خطورة وأهمية.",
    "sec1Items":{
      "1":{
        "title":"الحلول المؤسسية",
        "desc":"تخلص من المتاعب التي تواجهها في خطوط الإنتاج من خلال دمج الأنظمة الأساسية والأنظمة التي تعمل تلقائيًا على سير عملك. استنادًا إلى تقييم احتياجات عملك، نساعدك من خلال وضع استراتيجية لتنفيذ التغيير من أجل زيادة نتائج الأعمال بالصورة المطلوبة.",
        "url":"/services/"
      },
      "2":{
        "title":"حماية وأمان البرمجيات",
        "desc":"حافظ على أعمالك والعمليات الهامة التي تمتلكها آمنة من خلال خدمة حماية وأمان البرمجيات التي تضمن موثوقية الحل الخاص بك.",
        "url":"/services/security"
      }
    },
    "sec2":"اجعل الابتكار ضمن نسيج عملك.",
    "sec2Items":{
      "1":{
        "title":"صناعات محددة",
        "desc":"سواء كانت الرعاية الصحية أو الأغذية والمشروبات أو المواد البترولية والغاز، نساعدك من خلال خبراتنا السابقة في الصناعة في تخصيص حلول محددة للغاية تتناسب مع عملك."
      },
      "2":{
        "title":"نهج الشراكة",
        "desc":"لا نساعدك فقط في الحلول التكنولوجية أو الاستشارات، بل نستخدم شراكاتنا لتوسيع نمو أعمالك وخلق فرص للنمو."
      }
    },
    "sec3Items":{
      "1":{
        "title":"دراسة الجدوى للمشروع",
        "desc":"قبل أن تتحمل تكاليف التجربة والخطأ، ننصحك بإمكانية تنفيذ فكرتك وأفضل الطرق لتنفيذها من أجل عمليات دقيقة ونمو سريع."
      },
      "2":{
        "title":"زيادة الأداء",
        "desc":"سواء كان ذلك من خلال الأنظمة أو تكامل التكنولوجيا مثل إنترنت الأشياء، نعمل على التأكد من تحسين أدائك لتحقيق أفضل النتائج."
      },
      "3":{
        "title":"الأتمتة",
        "desc":"قلل من الوقت والجهد الضائعين على العمليات اليومية المتكررة التي تقوم بها، وركز مجهوداتك ومجهودات فريقك على العمليات الأكثر أهمية."
      }
    },
    "cta":"تميز بأعمالك من <br> خلال التكنولوجيا. "
  }
}
</i18n>
